// extracted by mini-css-extract-plugin
export default {"card":"Lesson_card__oNIRV","detailWrapper":"Lesson_detailWrapper__4zK+B"};